<template>
    <div class="success-msg-wrap">
        <h3>{{ req_support_success_msg }}</h3>
        <img v-if="req_support_success_image" :src="req_support_success_image">
        <router-link to="/support" class="btn btn-primary">Ok</router-link>
    </div>
</template>
<script>
export default {
    data() {
        return {
            req_support_success_msg: '',
            req_support_success_image: ''
        }
    },
    mounted() {
        this.get_settings()
    },
    methods: {
        get_settings() {
            this.$http.get('/api/settings?keys=["req_support_success_msg", "req_support_success_image"]')
                .then(response => {
                    let settings = response.data.data
                    for(let n in settings) {
                        this[settings[n].setting_key] = settings[n].setting_value
                    }
                })
        }
    }
}
</script>

<style lang="scss" scoped>
.success-msg-wrap {
    max-width: 992px;
    margin: 0 auto;
    text-align: center;
    h3 {
        padding: 0 0.5em;
    }
    .btn {
        margin: 1em auto;
        display: block;
        width: 100px;
    }
    img {
        margin-top: 0.5em;
        max-width: 420px;
        width: 100%;
    }
}
@media (max-width: 480px) {
    .success-msg-wrap {
        h3 {
            text-align: left;
        }
    }
}
</style>